import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withData from '@bd/bdcore-data';
import InsideHeader from '../../components/InsideHeader';
import Header from '../../components/Header';
import PageIntroBanner from '../../components/PageIntroBanner';
import ContactMenu from '../ContactUs/ContactMenu';


function ServiceRequestThankYou({ page }) {
  return (
    <div>
      <InsideHeader h1="Service Request" />
      <Header />
      <ContactMenu />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <PageIntroBanner
              h2="Thank You"
              p="For contacting us. We have recieved your request and will respond as soon as possible."
              background={_.get(page, 'intro_banner[0].photo.contentUrl')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

ServiceRequestThankYou.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({ page: 'service_request' })(ServiceRequestThankYou);



// WEBPACK FOOTER //
// ./src/pages/ServiceRequest/ServiceRequestThankYou.js